var map = {
	"./applepay.png": "37f1",
	"./atu_logo.png": "4522",
	"./body-shape/default/male/default.png": "1252",
	"./body_type_man.png": "5048",
	"./check_white.png": "c9fc",
	"./discover.png": "0a72",
	"./icon-touch.png": "c462",
	"./img.png": "ba75",
	"./img_1.png": "42ae",
	"./imgbig-Right-Bicep.png": "4984",
	"./imgbig-test.png": "a250",
	"./logo.png": "4ffd",
	"./logo_black.png": "70a5",
	"./mastercard.png": "ff57",
	"./muscle.png": "58fa",
	"./muscle1.png": "d537",
	"./paypallogo.png": "01fc",
	"./skate-quiz-pair-female.png": "e3c9",
	"./skate-quiz-pair-male.png": "74b2",
	"./skate-quiz-pair.png": "7686",
	"./skate-quiz-single-female.png": "9102",
	"./skate-quiz-single-male.png": "452e",
	"./skate-quiz-synchronized-female.png": "4fad",
	"./skate-quiz-synchronized-male.png": "8841",
	"./skate-quiz-synchronized.png": "51f2",
	"./skate-you-did-it.png": "51dc",
	"./skate_bronze.png": "4f75",
	"./skate_gold.png": "178d",
	"./skate_silver.png": "161d",
	"./videoplaybutton.png": "0f9e",
	"./visa.png": "073b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b967";